import { Link } from 'react-router-dom';
import styles from './Footer.module.css';

const Footer = (): React.ReactElement => (
  <footer className={styles.footer}>
    <div>EVENT.BLACK — identity infrastructure for autonomous agents</div>
    <div className={styles.links}>
      <Link to="/terms" className={styles.link}>Terms of Service</Link>
      <Link to="/privacy" className={styles.link}>Privacy Policy</Link>
      <Link to="/docs" className={styles.link}>Documentation</Link>
    </div>
  </footer>
);

export { Footer };
